import 'cropperjs/dist/cropper.css';

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay
} from '@chakra-ui/react';

type ModalConfirmProps = {
  isOpen: boolean;
  content: string;
  onClose: () => void;
  submit: () => void;
};

export const ModalConfirm = ({
  isOpen,
  content,
  onClose,
  submit
}: ModalConfirmProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        padding="30px"
        width="550px !important"
        height="330px !important"
        maxWidth="none !important"
        borderRadius="24px"
        background="#FFFFFF"
        boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
      >
        <ModalCloseButton
          _hover={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
          _active={{}}
        />
        <ModalBody
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontSize="1.25rem"
          fontWeight="700"
          lineHeight="2rem"
          padding="0px !important"
        >
          {content}
        </ModalBody>

        <ModalFooter justifyContent="space-between">
          <Button
            border="1px solid #001e64"
            bg="#fff"
            w="10rem"
            h="3rem"
            borderRadius="2rem"
            color="#001e64"
            onClick={onClose}
            transition="0.2s"
            _hover={{
              bg: '#001e64',
              border: '1px solid transparent',
              color: '#FFFFFF'
            }}
            _focus={{
              '&:focus': {
                boxShadow: 'none !important'
              }
            }}
            _active={{}}
          >
            Não
          </Button>
          <Button
            bg="#FA6B25"
            w="12rem"
            h="3rem"
            borderRadius="2rem"
            color="#fff"
            colorScheme="orange"
            border="1px solid transparent"
            onClick={() => {
              submit();
            }}
            transition="0.2s"
            _hover={{
              bg: '#FFFFFF',
              border: '1px solid #FA6B25',
              color: '#FA6B25'
            }}
            _focus={{
              '&:focus': {
                boxShadow: 'none !important'
              }
            }}
            _active={{}}
          >
            Sim
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
